import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  individualsService,
  VerifyIndividualEmailRequest,
  Individual,
} from '@aslanpay/portal-common-lib';

const useVerifyIndividualEmail = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, VerifyIndividualEmailRequest>) => {
  return useMutation<Individual, Error, VerifyIndividualEmailRequest>(
    ({ email, transactionId, code }: VerifyIndividualEmailRequest) =>
      individualsService.verifyIndividualEmail({ email: email.toLowerCase(), transactionId, code }),
    { onSuccess, onError }
  );
};

export default useVerifyIndividualEmail;
